import { getApiUrl, HttpError } from ".";
import { CrmPhoneActivityData, CrmPhoneActivityRecord, CrmRecord, CrmSettings } from "../model";


export async function apiFetch<T>(url: string, body: any, method: 'GET' | 'POST' = 'POST') {
  if (method === 'GET') {
    if (url.indexOf('?') === -1)
      url += '?'
  }

  body = { ...body }
  for (const key of Object.keys(body)) {
    const value = body[key]
    if (value === undefined) {
      delete body[key]
    } else {
      if (method === 'GET') {
        url += '&' + key + '=' + encodeURIComponent(value)
      }
    }
  }

  const x = getApiUrl(url)
  console.log('>>> ' + url + JSON.stringify(body))

  const resp = await fetch(x, { method: method, body: (method === 'GET') ? null : new URLSearchParams(body) })
  if (!resp.ok) { throw new HttpError(resp.status, resp.statusText, await resp.text()) }

  return await resp.json() as T
}

export async function searchCrmContacts(clid: string) {
  return await apiFetch<CrmRecord[]>('/api/Dynamics365/SearchContacts', { clid }, 'GET')
}

export async function searchCrmAccount(clid: string) {
  return await apiFetch<CrmRecord[]>('/api/Dynamics365/SearchAccounts', { clid }, 'GET')
}

export async function searchCrmAll(clid: string) {
  return await apiFetch<CrmRecord[]>('/api/Dynamics365/SearchAll', { clid }, 'GET')
}
export async function createCrmPhoneActivity(data: CrmPhoneActivityData) {
  return await apiFetch<CrmPhoneActivityRecord>('/api/Dynamics365/PhoneActivities', data)
}

export async function fetchCrmSettings() {
  return await apiFetch<CrmSettings>('api/Dynamics365/Settings', {}, 'GET')
}
